// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.promo-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 340px;
  background-color: var(--white);
}

.promo-image {
  width: 100%;
  border-radius: 4px;
  object-fit: cover;
}

.promo-content {
  text-align: center;
  margin-top: 16px;
}

.promo-title {
  font-size: 1.6em;
  font-weight: bold;
  color: var(--blue500);
  margin: 0;
}

.promo-body {
  font-size: 1.2em;
  color: var(--grey500);
  margin-top: 8px;
  margin-bottom: 8px;
  line-height: 30px;
  font-weight: 600;
  text-align: left;
}

.promo-link {
  display: inline-block;
  margin-top: 8px;
  color: var(--blue300);
  text-decoration: none;
  font-weight: 600;
  text-decoration: underline;
  text-align: left;
  font-size: 1.2em;
}

.promo-link:hover {
  text-decoration: underline;
}

@media screen and (max-width: 992px) {
  .promo-body {
    font-size: 1em;
    font-weight: 500;
  }
  .promo-title {
    font-size: 1.2em;
    font-weight: 600;
  }
  .promo-link {
    font-size: 1em;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/layout/promo-card/promo-card.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,8BAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,SAAA;AACF;;AAEA;EACE,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,qBAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE;IACE,cAAA;IACA,gBAAA;EACF;EAEA;IACE,gBAAA;IACA,gBAAA;EAAF;EAGA;IACE,cAAA;EADF;AACF","sourcesContent":[".promo-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  width: 340px;\r\n  background-color: var(--white);\r\n}\r\n\r\n.promo-image {\r\n  width: 100%;\r\n  border-radius: 4px;\r\n  object-fit: cover;\r\n}\r\n\r\n.promo-content {\r\n  text-align: center;\r\n  margin-top: 16px;\r\n}\r\n\r\n.promo-title {\r\n  font-size: 1.6em;\r\n  font-weight: bold;\r\n  color: var(--blue500);\r\n  margin: 0;\r\n}\r\n\r\n.promo-body {\r\n  font-size: 1.2em;\r\n  color: var(--grey500);\r\n  margin-top: 8px;\r\n  margin-bottom: 8px;\r\n  line-height: 30px;\r\n  font-weight: 600;\r\n  text-align: left;\r\n}\r\n\r\n.promo-link {\r\n  display: inline-block;\r\n  margin-top: 8px;\r\n  color: var(--blue300);\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n  text-decoration: underline;\r\n  text-align: left;\r\n  font-size: 1.2em;\r\n}\r\n\r\n.promo-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n@media screen and (max-width: 992px) {\r\n  .promo-body {\r\n    font-size: 1em;\r\n    font-weight: 500;\r\n  }\r\n\r\n  .promo-title {\r\n    font-size: 1.2em;\r\n    font-weight: 600;\r\n  }\r\n\r\n  .promo-link {\r\n    font-size: 1em;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
